export default __webpack_public_path__ + "static/media/truckFastag.a794709d.png";